import { useAppContext } from '../AppContext';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import html2canvas from 'html2canvas';
import { motion } from 'framer-motion';

import Footer from './Footer';

import AboutInvite from './AboutInvite';
import Affiliations from './Affiliations';
import Transition from './Transition';
import ReachYouForm from './ReachYouForm';
import { FaPhone, FaEnvelope, FaLinkedin, FaArrowRight, FaTimes } from 'react-icons/fa';

import skillsLogo from '../assets/images/about/toolsLogos.png'


import logoMini from '../assets/images/logo/netconn_engineering-compact.png';


import './about.css';
import ScreenSize from './ScreenSize';
import SvgCompanyLogo from './svgComponents/SvgCompanyLogo.tsx';


function About() {
  const { currentLanguage, setPage } = useAppContext();
  const navigate = useNavigate();

  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    setScrollPosition(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const getTransformStyle = () => {
    // Adjust the factor based on your preference
    const factor = 0.1;
    const translateX = `${scrollPosition * factor}px`;
    return { transform: `translateX(${translateX})` };
  };

  const formattedCompanyName = (inHeader) => {
    // const companyName = currentLanguage === 'አማርኛ' ? 'ኔትኮን' : 'netconn';
    const companyName = currentLanguage === 'አማርኛ' ? 'ኔትኮን' : "netconn";
    const nameLength = companyName.length;

    return (
      <span className='company-name'>
        {companyName.split(' ').map((word, wordIndex) => (
          inHeader ? (
            <span key={wordIndex}>
              {word.split('').map((char, charIndex) => (
                <span
                  key={charIndex}
                  style={
                    (wordIndex === 0) // Check if it's 'Puzzle' and apply color
                      ? { color: '#5733FF', borderBottom: '1px solid #474554' }
                      : { color: '#5733FF', textShadow: ' 4px 4px 12px rgba(255, 255, 0, 0.5)' } // Default color for 'Designs'
                  }
                >
                  {char}
                </span>
              ))}
              {wordIndex === 0 ? '' : ''} {/* Add space between words */}
            </span>
          ) :
            (
              <span key={wordIndex}>
                {word.split('').map((char, charIndex) => (
                  <span
                    key={charIndex}
                    style={
                      (wordIndex === 0 && charIndex % 2 === 1)
                        ? { color: '#474554' }
                        : { color: '#474554' }
                    }
                  >
                    {char}
                  </span>
                ))}
                {wordIndex === 0 ? '' : ''}
              </span>
            )
        )
        )
        }
      </span>
    );
  };

  const handleContactUs = () => {

    navigate('/contactus');
  };


  const [getInTouch, setGetInTouch] = useState(false);
  const [emailUs, setEmailUs] = useState(false);
  const [callUs, setCallUs] = useState(false);
  const CtaButton = () => {
    const buttonLabel = currentLanguage === 'English' ? 'Get in touch' : 'ያግኙን';
    return (
      <button className="cta-button" onClick={handleCTAClick}
        style={{
          transform: `${getInTouch ? "translateY(-10px) scale(0.8)" : ""} ${emailUs ? "translateY(-20px)" : ""}`,
          filter: getInTouch ? "grayscale(100%)" : "none",
          fontWeight: getInTouch ? "normal" : "bold",
        }}>{buttonLabel}</button>
    )
  }

  const handleCTAClick = () => {
    setGetInTouch(true);
  }

  const handleEmailUs = () => {
    setEmailUs(true);
    setCallUs(false);
  }
  const handleCallUs = () => {
    setCallUs(true);
    setEmailUs(false);
  }

  const handleCancel = () => {
    setGetInTouch(false);
    setEmailUs(false);
  }


  useEffect(() => {
    setPage('About');
  }, [])

  const bgColorPic = ['#ffd230', '#C7E6D7'];
  const [backgroundColorPic, setBackgroundColorPic] = useState('#ffd230')
  const handleContactMouseEnter = () => {
    let index = 0;
    const intervalId = setInterval(() => {
      index++;
      setBackgroundColorPic(bgColorPic[index % 2]);

      if (index >= 6) {
        clearInterval(intervalId);

      }


    }, 300);

    return () => {
      // Clean up
      clearInterval(intervalId);
    };
  };

  const downloadBusinessCard = () => {
    const cardContainer = document.querySelector('.business-card-container');

    html2canvas(cardContainer)
      .then((canvas) => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL();
        link.download = 'netconn-business-card.png';
        link.click();
      });
  };



  const pageSectionColors = ['#eceee0', '#ddd'];
  // const pageSellingsColors = ['#ffaaaa','#aaffaa'];
  const pageSellingsColors = ['#f5f5f5', '#474554'];

  const call_us = currentLanguage === 'English' ? 'Call Us' : 'ይደውሉልን';
  const email_us = currentLanguage === 'English' ? 'Email Us' : 'ኢሜይል ይጻፉልን';
  const download_label = currentLanguage === 'English' ? 'Download Business Card' : 'ቢዝነስ ካርዱን ያውርዱ'
  
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 430);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 430);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className='main-container'>
      {currentLanguage === 'English' && (
        <div className='about-container'>

          {/* <ScreenSize /> */}
          <div >
            <div className="motto-about" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
              <h1><span className='company-name'>{formattedCompanyName(true)}</span> - Crafting Digital Excellence with Passion and Precision.</h1>
              
             {/* <div className='promo-img-container'>
              <motion.img
                src={promoFacts}
                alt='company promo, netconn'
                className='logo-motto2'
                initial={{ scale: 1, y: 0, x: 0 }} // Initial scale and y position
                animate={{ 
                  scale: isLargeScreen ? [1, 4, 1] : [1, 3, 1],
                  y: isLargeScreen?[0, -100, 0]:[0, -20, 0], 
                  x: isLargeScreen?[0, -20, 0]:[0, -20, 0] }} // Animate scale from normal to zoomed and back, and y position
                transition={{ duration: 5, repeat: Infinity }} // Duration of animation and repeat indefinitely
              />
              </div> */}
              <SvgCompanyLogo />
            </div>
            <div className='about-company'>

            <p style={{zIndex: 1}}>NetConn Engineering Software, established in 2011, is a dynamic provider of technology and excellence. 
                            We offer a comprehensive suite of IT and office automation solutions, driving innovation across diverse sectors. 
                            Our focus on client satisfaction and long-term partnerships drives us to go above and beyond in all our engagements, ensuring success for both our clients and our company.
                            </p>
              <p className='about-reNiche'>Website Design | App Design | Brand Design | Office Software Solutions | AI Powered Advancements | Tailored to Ethiopia's Market </p>
            </div>

      
          </div>

          <div className='about-sellingpoints' style={{ backgroundColor: pageSectionColors[1] }}>
            <h2 className='sub-header'><span className='company-name' style={{ lineHeight: '1.5', letterSpacing: '1.2rem', fontSize: '48px' }}>{formattedCompanyName(false)}</span><br /> at a glance</h2>

            <div style={{ color: pageSellingsColors[1], backgroundColor: pageSellingsColors[0], margin: 'auto' }}
              className='sellingpoints-container'>


              <div
                style={{
                  position: 'relative',
                  backgroundColor: pageSellingsColors[1],
                }}
                className='sellingpoints-title'>
                <p style={{ zIndex: '98', color: pageSellingsColors[0] }}>Quick Facts</p>
                {/* <div style={{ backgroundColor: '#ffd230', width: '50px', height: '50px' }} className='bubble'></div> */}
                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    left: 0,
                    width: 25, // Adjust the width to control the size of the point of light
                    height: 25, // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 210, 30, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    right: 0,
                    width: 25, // Adjust the width to control the size of the point of light
                    height: 25, // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 150, 120, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLightRight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
              </div>
              <ul className='intro-text'>
                <li>Innovative software and tech service in Ethiopia</li>
                <li>Founded in 2011</li>
                <li>13+ years of experience</li>
                <li>Guided by strong will to help businesses thrive</li>

              </ul>

            </div>
            <div style={{ color: pageSellingsColors[0], backgroundColor: pageSellingsColors[1], margin: 'auto' }}
              className='sellingpoints-container'>


              <div className='sellingpoints-title'
                style={{
                  backgroundColor: pageSellingsColors[0],
                  position: 'relative'
                }}>
                <p style={{ zIndex: '98' }}>Services and Products</p>
                <div style={{
                  backgroundColor: '#896862', position: 'absolute',
                  top: '50%', left: '50%'
                }} className='medium-bubble-intro'></div>
              </div>
              <ul className='intro-text'
                style={{ color: pageSellingsColors[0] }}>
                <li>Website Designs</li>
                <li>App Design</li>
                <li>Brand Design</li>
                <li>Office Software Solutions</li>
                <li>AI Powered Advancements</li>

              </ul>

            </div>

            <div style={{ color: pageSellingsColors[1], backgroundColor: pageSellingsColors[0], margin: 'auto' }}
              className='sellingpoints-container'>
              <div style={{
                position: 'relative',
                backgroundColor: pageSellingsColors[1]
              }} className='sellingpoints-title'>
                <p style={{ zIndex: '98', color: pageSellingsColors[0] }}>Business Niche</p>
                {/* <div style={{ backgroundColor: '#ffff00', width: '150px', height: '150px' }} className='bubble'></div> */}
                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    left: 0,
                    width: '25px', // Adjust the width to control the size of the point of light
                    height: '25px', // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 210, 30, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    right: 0,
                    width: '25px', // Adjust the width to control the size of the point of light
                    height: '25px', // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 150, 50, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLightRight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
              </div>

              {/* <h3 className='about-title'>Focus Areas</h3> */}
              <ul className='intro-text'>
                <li>Office</li>
                <li>Ecommerce</li>
                <li>Social services </li>
                <li>Education</li>
                <li>Tourism</li>
                <li>Automation</li>
              </ul>
            </div>

            <div style={{ color: pageSellingsColors[0], backgroundColor: pageSellingsColors[1], margin: 'auto' }}
              className='sellingpoints-container'>
              <div className='sellingpoints-title'
                style={{
                  overflow: 'hidden',
                  backgroundColor: pageSellingsColors[0],
                  position: 'relative'
                }}>
                <p style={{ zIndex: '98' }}>Business Approaches</p>

                <div style={{
                  backgroundColor: '#ffff00', position:
                    'absolute', top: '50%', left: '50%'
                }} className='medium-bubble-intro'></div>

              </div>

              <ul className='intro-text'
                style={{ color: pageSellingsColors[0] }}>

                <li>Professional</li>
                <li>Structured</li>
                <li>Timely followup</li>
                <li>Tailored design</li>
                <li>On-time delivery</li>
                <li>Cooperative approach</li>
              </ul>
            </div>

            <div className='sellingpoints-container'
              style={{ color: pageSellingsColors[1], backgroundColor: pageSellingsColors[0], margin: 'auto' }}>
              <div className='sellingpoints-title'
                style={{
                  overflow: 'hidden',
                  backgroundColor: pageSellingsColors[1],
                  position: 'relative'
                }}>
                <p style={{ zIndex: '98', color: pageSellingsColors[0] }}>Tools and Technologies</p>

                {/* <div style={{ backgroundColor: '#C7E6D7', overflowY: 'hidden' }} className='medium-bubble-intro'></div> */}

                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    left: 0,
                    width: 25, // Adjust the width to control the size of the point of light
                    height: 25, // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 210, 30, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    right: 0,
                    width: 25, // Adjust the width to control the size of the point of light
                    height: 25, // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 150, 120, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLightRight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
              </div>
              <div className='intro-text-img'>
                <div >
                  <img src={skillsLogo} alt="Representation of netconn's core competencies, including expertise in software development, hardware solutions, and efficient project management."


                  ></img>

                </div>
              </div>


            </div>
            {/* <HorizontalScrollLogo /> */}






          </div>
          <div style={{ padding: '24px', backgroundColor: pageSectionColors[0] }}>

            <AboutInvite />

          </div>

          {/* <div
            style={{
              backgroundColor: pageSectionColors[1],


            }}
            className='team-container'>

            <div className='member-container'>
              <img src={ceoPic}
                alt="Portrait of Bruk Tadesse, Founder and Software/Electronics Engineer at netconn."

                className='teamPic'
                style={{ backgroundColor: backgroundColorPic }}></img>
              <div className='member-info'>
                <p className='name'>Biruk Tadesse</p>
                <p className='title'>Founder and Software/Electronics Engineer @netconn</p>
                <p className='areas'>Website | App | Brand | Office Software | AI Consultancy</p>
                <button className="cta-contactus" onClick={handleContactUs}
                  onMouseEnter={handleContactMouseEnter}
                >Contact Us</button>
              </div>
            </div>





          </div> */}
          <div style={{ backgroundColor: pageSectionColors[0] }}>
            <Affiliations />
          </div>

          <div className='cfa'
            style={{ position: 'relative' }}>
            <CtaButton />
            {getInTouch && (

              <button onClick={() => handleCancel()}
                className='cancel-button'>
                <FaTimes />
              </button>


            )}
            {getInTouch && (

              <div style={{
                display: 'flex', justifyContent: 'space-evenly', width: '100%',
                boxShadow: '4px 4px 12px rgba(255, 216, 178, 0.5)',
                transform: emailUs ? "translateY(-10px)" : '',

              }}>
                <div style={{
                  backgroundColor: '#aaffaa', padding: '10px',
                  filter: emailUs ? "grayscale(100%)" : "none",
                  opacity: emailUs ? '0.5' : '1',
                  border: callUs ? '2px solid #474554' : '',
                  borderRadius: callUs ? '10px 4px' : '',
                  fontWeight: callUs ? 'bold' : 'normal',
                }}
                  className='contact-item'
                  onClick={handleCallUs}>
                  <p>
                    <FaPhone /> <a href="tel:+251974052565" >Call Us</a>
                  </p>
                </div>

                <div style={{
                  backgroundColor: '#aaaaff', padding: '10px',
                  cursor: 'pointer', border: emailUs ? '2px solid #474554' : '',
                  borderRadius: emailUs ? '10px 4px' : '',
                  fontWeight: emailUs ? 'bold' : 'normal',
                  filter: callUs ? "grayscale(100%)" : "none",
                  opacity: callUs ? '0.5' : '1'
                }}
                  className='contact-item'
                  onClick={handleEmailUs}
                >
                  <p>
                    <FaEnvelope /> Email Us
                  </p>

                </div>
              </div>

            )}
            {getInTouch && (

              <div
                className='cfa-logo-container'>
                <img src={logoMini} alt='company logo, netconn' className='logo-cfa'></img>
              </div>


            )}
            {emailUs && getInTouch && (
              <div className='reach-you-form-container'>
                <ReachYouForm />
              </div>



            )}


          </div>
          <Footer />
        </div>


      )}
      {currentLanguage === 'አማርኛ' && (
        <div className='about-container'>

          {/* <ScreenSize /> */}
          <div >
            <div className="motto-about" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
              <h1> <span className='company-name'>{formattedCompanyName(true)}</span>
                እንባላለን ፤ ዲጂታል ልቀትን ከልብና ለለውጥ የምንሠራ</h1>
                {/* <div className='promo-img-container'>
              <motion.img
                src={promoFactsAmh}
                alt='company promo, netconn'
                className='logo-motto2'
                initial={{ scale: 1, y: 0, x: 0 }} // Initial scale and y position
                animate={{ 
                  scale: isLargeScreen ? [1, 4, 1] : [1, 3, 1],
                  y: isLargeScreen?[0, -100, 0]:[0, -20, 0], 
                  x: isLargeScreen?[0, -20, 0]:[0, -20, 0] }} // Animate scale from normal to zoomed and back, and y position
                transition={{ duration: 5, repeat: Infinity }} // Duration of animation and repeat indefinitely
              />
              </div> */}
               <SvgCompanyLogo />

            </div>
            <div className='about-company'>

             <p>በ 2004 ዓ.ም የተቋቋመው ኔትኮን ኢንጅነሪንግ በሶፍትዌር ተለዋዋጭ የቴክኖሎጂ እና የልህቀት አቅራቢ ነው። ሁለንተናዊ የአይቲ እና የቢሮ አውቶሜሽን መፍትሄዎችን እናቀርባለን ፣በተለያዩ ዘርፎች አዳዲስ ፈጠራዎችን ማቅረብ የቀን ተቀን ሥራችን ነው፡፡
               
               <p>ትኩረት ያለው የደንበኛን ፍላጎት የመረዳትና ይህንንም ፍላጎት ትርጉምና ቅልጥፍናን በሚያጎናጽፍ የሶፍትዌር ሥራ እናሳካለን፡፡ </p> 
               
               <p>የደንበኛ እርካታ እና የረጅም ጊዜ ሽርክናዎች ላይ በሁሉም ተግባሮቻችን ላይ መሠረት ዘርግተን እንንቀሳቀሳለን፡፡ ይህም ለደንበኞቻችን እና ለኩባንያችን ስኬትን እንድናረጋግጥ በከፍተኛ ሁኔታ ይረዳናል። </p>
               </p>
              <p className='about-reNiche'>የዌብሳይት ዲዛይን | የሞባይል መተግበሪያ ዲዛይን | ብራንድ ዲዛይን | የቢሮ ሶፍትዌር መፍትሄዎች | AI ኮንሳልታንሲ | ለኢትዮጵያ ገበያ ታቅዶ የተዘጋጀ </p>
            </div>

        
          </div>

          <div className='about-sellingpoints' style={{ backgroundColor: pageSectionColors[1] }}>
            <h2 className='sub-header'><span className='company-name' style={{ lineHeight: '1.5', letterSpacing: '1.2rem', fontSize: '48px' }}>{formattedCompanyName(false)}</span><br /> በትንሹ</h2>

            <div style={{ color: pageSellingsColors[1], backgroundColor: pageSellingsColors[0], margin: 'auto' }}
              className='sellingpoints-container'>


              <div
                style={{
                  position: 'relative',
                  backgroundColor: pageSellingsColors[1],
                }}
                className='sellingpoints-title'>
                <p style={{ zIndex: '98', color: pageSellingsColors[0] }}>ፈጣን እውነታዎች</p>
                {/* <div style={{ backgroundColor: '#ffd230', width: '50px', height: '50px' }} className='bubble'></div> */}
                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    left: 0,
                    width: 25, // Adjust the width to control the size of the point of light
                    height: 25, // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 210, 30, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    right: 0,
                    width: 25, // Adjust the width to control the size of the point of light
                    height: 25, // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 150, 120, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLightRight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
              </div>
              <ul className='intro-text'>
                <li>የፈጠራ ሶፍትዌር እና የቴክኖሎጂ አገልግሎቶች ለኢትዮጵያ ገበያ</li>
                <li>በ2004 ዓ.ም ተመሠረተ</li>
                <li>+13 ዓመት የሥራ ልምድ</li>
                <li>የኢትዮጵያ ቢዝነሶች/ኢንተርፕራይዞች በቴክኖሎጂ እንዲጎለብቱ መርዳት</li>

              </ul>

            </div>
            <div style={{ color: pageSellingsColors[0], backgroundColor: pageSellingsColors[1], margin: 'auto' }}
              className='sellingpoints-container'>


              <div className='sellingpoints-title'
                style={{
                  backgroundColor: pageSellingsColors[0],
                  position: 'relative'
                }}>
                <p style={{ zIndex: '98' }}>አገልግሎቶችና ምርቶች</p>
                <div style={{
                  backgroundColor: '#896862', position: 'absolute',
                  top: '50%', left: '50%'
                }} className='medium-bubble-intro'></div>
              </div>
              <ul className='intro-text'
                style={{ color: pageSellingsColors[0] }}>
                <li>ዌብሳይት ዲዛይን</li>
                <li>ሞባይል መተግበሪያ ዲዛይን</li>
                <li>ብራንድ ዲዛይን</li>
                <li>የቢሮ ሶፍትዌር መፍትሄዎች</li>
                <li>AI መርህ መፍትሄዎች</li>

              </ul>

            </div>

            <div style={{ color: pageSellingsColors[1], backgroundColor: pageSellingsColors[0], margin: 'auto' }}
              className='sellingpoints-container'>
              <div style={{
                position: 'relative',
                backgroundColor: pageSellingsColors[1]
              }} className='sellingpoints-title'>
                <p style={{ zIndex: '98', color: pageSellingsColors[0] }}>ዒላማ ንግድ/ሥራ ዓይነቶች</p>
                {/* <div style={{ backgroundColor: '#ffff00', width: '150px', height: '150px' }} className='bubble'></div> */}
                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    left: 0,
                    width: '25px', // Adjust the width to control the size of the point of light
                    height: '25px', // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 210, 30, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    right: 0,
                    width: '25px', // Adjust the width to control the size of the point of light
                    height: '25px', // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 150, 50, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLightRight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
              </div>

              {/* <h3 className='about-title'>Focus Areas</h3> */}
              <ul className='intro-text'>
                <li>ቢሮ</li>
                <li>ኢኮሜርስ</li>
                <li>ማህበራዊ አገልግሎት </li>
                <li>ትምህርት</li>
                <li>ቱሪዝም</li>
                <li>አውቶሜሽን</li>
              </ul>
            </div>

            <div style={{ color: pageSellingsColors[0], backgroundColor: pageSellingsColors[1], margin: 'auto' }}
              className='sellingpoints-container'>
              <div className='sellingpoints-title'
                style={{
                  overflow: 'hidden',
                  backgroundColor: pageSellingsColors[0],
                  position: 'relative'
                }}>
                <p style={{ zIndex: '98' }}>የሥራ አቀራረባችን</p>

                <div style={{
                  backgroundColor: '#ffff00', position:
                    'absolute', top: '50%', left: '50%'
                }} className='medium-bubble-intro'></div>

              </div>

              <ul className='intro-text'
                style={{ color: pageSellingsColors[0] }}>

                <li>ፕሮፌሽናል</li>
                <li>የተዋቀረ</li>
                <li>ወቅታዊ ክትትል</li>
                <li>የተበጀ ንድፍ</li>
                <li>በጊዜ የሚደርስ</li>
                <li>የህብረት ስራ</li>
              </ul>
            </div>

            <div className='sellingpoints-container'
              style={{ color: pageSellingsColors[1], backgroundColor: pageSellingsColors[0], margin: 'auto' }}>
              <div className='sellingpoints-title'
                style={{
                  overflow: 'hidden',
                  backgroundColor: pageSellingsColors[1],
                  position: 'relative'
                }}>
                <p style={{ zIndex: '98', color: pageSellingsColors[0] }}>ቴክኖሎጂዎችና መሳሪያዎች</p>

                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    left: 0,
                    width: 25, // Adjust the width to control the size of the point of light
                    height: 25, // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 210, 30, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '80%',
                    right: 0,
                    width: 25, // Adjust the width to control the size of the point of light
                    height: 25, // Adjust the height to control the size of the point of light
                    borderRadius: '50%', // Create a circular shape
                    background: 'radial-gradient(circle, rgba(255, 150, 120, 0.5) 0%, rgba(255, 255, 255, 0) 80%)',
                    animation: 'moveReflectiveLightRight 10s linear infinite', // Adjust the duration as needed
                  }}
                />
              </div>
              <div className='intro-text-img'>
                <div >
                  <img src={skillsLogo} alt="Representation of netconn's core competencies, including expertise in software development, hardware solutions, and efficient project management."


                  ></img>

                </div>
              </div>


            </div>
            {/* <HorizontalScrollLogo /> */}






          </div>
          <div style={{ padding: '24px', backgroundColor: pageSectionColors[0] }}>

            <AboutInvite />

          </div>

       
          <div style={{ backgroundColor: pageSectionColors[0] }}>
            <Affiliations />
          </div>

          <div className='cfa'
            style={{ position: 'relative' }}>
            <CtaButton />
            {getInTouch && (

              <button onClick={() => handleCancel()}
                className='cancel-button'>
                <FaTimes />
              </button>


            )}
            {getInTouch && (

              <div style={{
                display: 'flex', justifyContent: 'space-evenly', width: '100%',
                boxShadow: '4px 4px 12px rgba(255, 216, 178, 0.5)',
                transform: emailUs ? "translateY(-10px)" : '',

              }}>
                <div style={{
                  backgroundColor: '#aaffaa', padding: '10px',
                  filter: emailUs ? "grayscale(100%)" : "none",
                  opacity: emailUs ? '0.5' : '1',
                  border: callUs ? '2px solid #474554' : '',
                  borderRadius: callUs ? '10px 4px' : '',
                  fontWeight: callUs ? 'bold' : 'normal',
                }}
                  className='contact-item'
                  onClick={handleCallUs}>
                  <p>
                    <FaPhone /> <a href="tel:+251974052565" >{call_us}</a>
                  </p>
                </div>

                <div style={{
                  backgroundColor: '#aaaaff', padding: '10px',
                  cursor: 'pointer', border: emailUs ? '2px solid #474554' : '',
                  borderRadius: emailUs ? '10px 4px' : '',
                  fontWeight: emailUs ? 'bold' : 'normal',
                  filter: callUs ? "grayscale(100%)" : "none",
                  opacity: callUs ? '0.5' : '1'
                }}
                  className='contact-item'
                  onClick={handleEmailUs}
                >
                  <p>
                    <FaEnvelope /> {email_us}
                  </p>

                </div>
              </div>

            )}
            {getInTouch && (

              <div
                className='cfa-logo-container'>
                <img src={logoMini} alt='company logo, netconn' className='logo-cfa'></img>
              </div>


            )}
            {emailUs && getInTouch && (
              <div className='reach-you-form-container'>
                <ReachYouForm />
              </div>



            )}


          </div>
          <Footer />
        </div>


      )}

    </div>

  );
}

export default Transition(About, 'About');
